export default __webpack_public_path__ + "68fd61763d127b95378731c53739199e.svg";